const { handleRequest } = require("helpers");

export const getList = async (master_key = '') => {
    try {
        if (!master_key) {
            console.warn("Master key is required to fetch meta-data list.");
            return [];
        }
        const res = await handleRequest(`/meta-data/list-elements?master_key=${master_key}&paranoid=false`);
        if (res.success && res.status === 200) {
            return res.data;
        }
        return [];
    } catch (e) {
        console.log(e);
    }
}

export const getProvinces = async (filters = {}) => {
    try {
        const filterString = Object.keys(filters).map(key => `${key}:${filters[key]}`).join(',');
        const res = await handleRequest(`/provinces/?filters=${filterString}`);
        if (res.success && res.status === 200) {
            return res.data;
        }
        return [];
    } catch (e) {
        console.log(e);
    }
}

export const getDistricts = async (filters = {}) => {
    try {
        const filterString = Object.keys(filters).map(key => `${key}:${filters[key]}`).join(',');
        const res = await handleRequest(`/districts/?filters=${filterString}`);
        if (res.success && res.status === 200) {
            return res.data;
        }
    } catch (e) {
        console.log(e);
    }
}

export const getTehsils = async (filters = {}) => {
    try {
        const filterString = Object.keys(filters).map(key => `${key}:${filters[key]}`).join(',');
        const res = await handleRequest(`/tehsils/?filters=${filterString}`);
        if (res.success && res.status === 200) {
            return res.data;
        }
    } catch (e) {
        console.log(e);
    }
}

export const getUcs = async (filters = {}) => {
    try {
        const filterString = Object.keys(filters).map(key => `${key}:${filters[key]}`).join(',');
        const res = await handleRequest(`/ucs/?filters=${filterString}`);
        if (res.success && res.status === 200) {
            return res.data;
        }
    } catch (e) {
        console.log(e);
    }
}